import "./subject_type.scss"

